import { NavLink } from 'react-router-dom';
import { motion } from 'framer-motion';
import { cn } from '../../lib/utils';
import { NAV_ITEMS } from '../../lib/constants';

/** Mobile bottom navigation (sidebar collapses to this on small screens). */
export default function BottomNav() {
  return (
    <nav className="glass-strong fixed inset-x-0 bottom-0 z-40 flex items-center justify-around border-t border-border/60 px-2 pb-[env(safe-area-inset-bottom)] pt-1 md:hidden">
      {NAV_ITEMS.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          className={({ isActive }) =>
            cn(
              'relative flex flex-1 flex-col items-center gap-1 rounded-lg py-2 text-[11px] font-medium transition-colors',
              isActive ? 'text-brand-300' : 'text-content-subtle'
            )
          }
        >
          {({ isActive }) => (
            <>
              {isActive && (
                <motion.span
                  layoutId="bottomnav-active"
                  className="absolute -top-0.5 h-1 w-8 rounded-full bg-brand-400"
                />
              )}
              <item.icon className="h-5 w-5" />
              <span>{item.label}</span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
